var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3541 2.2528C8.54831 1.69356 7.45171 1.69356 6.64591 2.2528L2.38676 5.20875C1.71586 5.67437 1.6467 6.58299 2.22499 7.13485C2.67101 7.56048 2.92621 8.14289 2.92621 8.7554V12.0072C2.92621 13.1781 3.92778 14.1667 5.21311 14.1667H10.7869C12.0722 14.1667 13.0738 13.1781 13.0738 12.0072V8.7554C13.0738 8.14289 13.329 7.56048 13.775 7.13485C14.3533 6.58299 14.2842 5.67437 13.6133 5.20875L9.3541 2.2528ZM6.07575 1.43127C7.22441 0.634075 8.7756 0.634075 9.92427 1.43127L14.1834 4.38722C15.3667 5.20844 15.5083 6.86309 14.4654 7.8583C14.2117 8.10039 14.0738 8.42361 14.0738 8.7554V12.0072C14.0738 13.774 12.5799 15.1667 10.7869 15.1667H5.21311C3.42011 15.1667 1.92621 13.774 1.92621 12.0072V8.7554C1.92621 8.42361 1.7883 8.10039 1.53461 7.8583L1.87526 7.50133L1.53461 7.8583C0.491729 6.86309 0.633313 5.20844 1.8166 4.38722L6.07575 1.43127ZM6.16668 12C6.16668 11.7239 6.39053 11.5 6.66668 11.5H9.33334C9.60948 11.5 9.83334 11.7239 9.83334 12C9.83334 12.2762 9.60948 12.5 9.33334 12.5H6.66668C6.39053 12.5 6.16668 12.2762 6.16668 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandSummary);
export default __webpack_public_path__ + "static/media/brand-summary.69719dba816eca1b5c979f43e4d1d633.svg";
export { ForwardRef as ReactComponent };